exports = module.exports = require("../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-header {\n  background-color: #434954;\n  padding: 16px;\n  width: 100%;\n  min-height: 150px;\n  text-align: center;\n}\n\n.about-header img {\n  max-width: 200px;\n  min-height: 115px;\n  margin-left: -15px;\n  padding: 25px 0 20px 0;\n}\n\n.about-info p {\n  color: #697072;\n  text-align: left;\n}\n\n.about-info ion-icon {\n  width: 20px;\n}\n\n.md .about-info [text-right],\n.wp .about-info [text-right] {\n  margin-right: 0;\n}\n\n.ios .about-info {\n  text-align: center;\n}\n\n.ios .about-info ion-icon {\n  width: auto;\n  margin-right: 10px;\n}\n", ""]);

// exports
